"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_helper_1 = require("../helpers/cookie-helper");
var NavbarDisplay = (function () {
    function NavbarDisplay() {
    }
    NavbarDisplay.prototype.showLogedIn = function (user, response) {
        if (user.isLogggedIn()) {
            $('.logged-in').show();
            $('.logged-out').hide();
            $('.welcome-username').html(cookie_helper_1.default.get('uName'));
            $('.credit-balance').html(response.Data.AuthUserResponse[0]['Credit']);
            $('.currency-balance').html(response.Data.AuthUserResponse[0]['Currency']);
        }
    };
    NavbarDisplay.prototype.showUpdatedCredit = function (user, response) {
        if (user.isLogggedIn()) {
            $('.logged-in').show();
            $('.logged-out').hide();
            $('.welcome-username').html(user.username);
            $('.credit-balance').html(response.Credit);
            $('.currency-balance').html(cookie_helper_1.default.get('currency'));
        }
    };
    NavbarDisplay.prototype.showLogedOut = function () {
        $('.logged-in').hide();
        $('.logged-out').show();
        $('.welcome-username').empty();
        $('.credit-balance').empty();
        $('.currency-balance').empty();
    };
    return NavbarDisplay;
}());
exports.default = NavbarDisplay;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/navbar/navbar-display.ts
// module id = 190
// module chunks = 5